import { useQuery } from '@tanstack/react-query';
import { Dispatch, SetStateAction, useEffect } from 'react';

import api from 'utils/api';
import { useFetchBuoys } from '../../tables/state';

export type FormSensorType = {
  ownerSensorId: number;
  ownerSensorClassId: number;
};

export const useAddEventModal = ({
  setSnackbar,
  selectedBuoyId,
  setSelectedSensors,
  triggerUpdate = true
}: {
  selectedBuoyId: number;
  setSelectedSensors: (ids: Array<FormSensorType>) => void;
  setSnackbar: Dispatch<SetStateAction<string>>;
  triggerUpdate?: boolean;
}) => {
  const {
    buoys,
    isLoading: isGetBuoysPending,
    error: getBuoysError
  } = useFetchBuoys();

  const {
    data: sensors,
    isPending: isGetSensorsPending,
    error: getSensorsError
  } = useQuery<
    Array<{
      ownerSensorClassId: number;
      ownerSensorId: number;
      sensorClass: string;
      sensorId: string;
    }>
  >({
    queryKey: ['add-event-modal', 'sensors', selectedBuoyId],
    queryFn: () =>
      api
        .get(
          `/admin/sensorsByBuoyId?${new URLSearchParams({ buoyId: selectedBuoyId.toString() }).toString()}`
        )
        .then((res) => res.data),
    enabled: !!selectedBuoyId,
    staleTime: 0
  });

  useEffect(() => {
    if (getSensorsError && getSensorsError !== null) {
      setSnackbar(getSensorsError.message);
    }
  }, [getSensorsError]);

  useEffect(() => {
    if (sensors && triggerUpdate) {
      setSelectedSensors(
        sensors.map(({ ownerSensorId, ownerSensorClassId }) => ({
          ownerSensorClassId,
          ownerSensorId
        }))
      );
    }
  }, [sensors]);

  return {
    // Buoys
    buoys,
    isGetBuoysPending,
    getBuoysError,

    // Sensors
    sensors,
    isGetSensorsPending,
    getSensorsError
  };
};
